import PropTypes from 'prop-types';

import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { assignmentTypeEnum, workReportLineStatus } from '../../../utils/dataStatus';
import { Line } from '../../../utils/globalPropTypes';
import { AttachedFilesPermissions } from '../../MonthlyServiceRequest/RequestDetailTypes';

const ModalLineMenu = (props) => {
  const {
    line,
    showModalMenu,
    setShowModalMenu,
    setWorkReportLines,
    setShowDeleteModal,
    disabledByView,
    disabledDeleteAction,
    disabledRectifyLine,
    disabledEditStateCancelOrFinish,
    monthly,
    hideButton,
    labelButtonDetele,
    filesPermissions,
    setIsRectifyAmount,
    selectedDate,
    setAmount,
    amount,
    disabledPPModal,
    setNewFetch,
    idLocation
  } = props;

  const { activeMonthlySummaryModal, activeProgramPointModal } = useWorkReportModals();

  return (
    <div
      className="modal_menu"
      style={{
        display: !showModalMenu ? 'none' : 'block'
      }}
    >
      <ul className="options_modal_line_row shadow">
        {line.estadoEnum === workReportLineStatus.enviar && (
          <li>
            <button
              className="button_modal_row_actions"
              disabled={
                (line.estadoEnum > workReportLineStatus.enviar &&
                  line.estadoEnum !== workReportLineStatus.devolver) ||
                (line.estadoEnum !== workReportLineStatus.enviar &&
                  line.estadoEnum !== workReportLineStatus.devolver) ||
                disabledByView ||
                disabledRectifyLine ||
                line.cantidad === null
              }
              onClick={() => {
                // Enable the selected idParteDiario among the stored lines
                // and set the property disabled: false to enable it

                if (!line?.tienePuntosPrograma) {
                  setWorkReportLines((lines) =>
                    lines.map((disabledLine) => {
                      if (line.idParteDiario === disabledLine.idParteDiario) {
                        return {
                          ...disabledLine,
                          disabled: false,
                          colores: '#000000,#FFFFFF'
                        };
                      }

                      return disabledLine;
                    })
                  );
                } else {
                  activeProgramPointModal({
                    line,
                    selectedDate,
                    setAmount,
                    amount,
                    disabledPPModal,
                    tienePuntosPrograma: line?.tienePuntosPrograma,
                    setIsRectifyAmount,
                    isRectifyAmount: true,
                    setNewFetch
                  });
                }
                setShowModalMenu(false);
                setIsRectifyAmount(true);
              }}
              type="button"
            >
              Rectificar cantidad
            </button>
          </li>
        )}
        <li>
          <button
            className="button_modal_row_actions"
            disabled={disabledDeleteAction || disabledEditStateCancelOrFinish}
            onClick={() => {
              setShowDeleteModal(true);
              setShowModalMenu(false);
            }}
            type="button"
          >
            {labelButtonDetele || 'Eliminar línea'}
          </button>
        </li>
        {!hideButton && (
          <li>
            <button
              className="button_modal_row_actions"
              onClick={() => {
                activeMonthlySummaryModal({
                  dailyWorkReport: {
                    idLocation,
                    idParteLinea: monthly ? line?.idUbicacionLinea : line.idParteLinea,
                    idParteTrabajo: line?.idPartetrabajo,
                    tipoAsignacion: monthly ? assignmentTypeEnum.Mensualizada : null
                  },
                  monthly,
                  filesPermissions
                });

                setShowModalMenu(false);
              }}
              type="button"
            >
              Ver total de líneas
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

ModalLineMenu.propTypes = {
  line: Line.isRequired,
  showModalMenu: PropTypes.bool.isRequired,
  setShowModalMenu: PropTypes.func.isRequired,
  setWorkReportLines: PropTypes.func,
  setShowDeleteModal: PropTypes.func.isRequired,
  disabledByView: PropTypes.bool,
  disabledDeleteAction: PropTypes.bool,
  disabledRectifyLine: PropTypes.bool,
  disabledEditStateCancelOrFinish: PropTypes.bool,
  monthly: PropTypes.bool,
  hideButton: PropTypes.bool,
  labelButtonDetele: PropTypes.string,
  filesPermissions: AttachedFilesPermissions,
  setIsRectifyAmount: PropTypes.func,
  selectedDate: PropTypes.string,
  setAmount: PropTypes.func,
  amount: PropTypes.string,
  disabledPPModal: PropTypes.bool,
  setNewFetch: PropTypes.func,
  idLocation: PropTypes.number
};

ModalLineMenu.defaultProps = {
  disabledByView: false,
  setWorkReportLines: () => {
    /* empty */
  },
  disabledDeleteAction: false,
  disabledRectifyLine: false,
  monthly: false,
  hideButton: false,
  labelButtonDetele: null,
  filesPermissions: {
    visualize: false,
    write: false
  },
  setIsRectifyAmount: () => {
    /* empty */
  },
  selectedDate: '',
  setAmount: () => {
    /* empty */
  },
  amount: '',
  disabledPPModal: false,
  setNewFetch: () => {
    /* empty */
  },
  disabledEditStateCancelOrFinish: false,
  idLocation: null
};

export default ModalLineMenu;
